import { memo, useEffect } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";

function RejoinComp() {
  const { __merchantId, __userId, __appConfirmUniqueID, grp } =
    useLiveStreamAppContext();

  const apiUrlRejoin = process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", grp);
  // const apiUrlRejoin =
  //   grp.toLowerCase() === "us02"
  //     ? process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", grp).replace(
  //         "api.vagaro.com",
  //         "as-prod-us02-apiv2-merchant.azurewebsites.net"
  //       )
  //     : process.env.REACT_APP_API_URL_FOR_REJOIN.replace("us02", grp);

  //Rejoin Callback Component for iOS
  useEffect(() => {
    if (navigator.userAgent.indexOf("com.vagaro.customerios") > -1) {
      var rejoinData =
        '{"message": "","messageType": 0,"screenTitle":"","screenType": 0,"navType": 0,"action": "54|~|' +
        __appConfirmUniqueID +
        "|~|" +
        __merchantId +
        "|~|" +
        __userId +
        "|~|" +
        apiUrlRejoin +
        "|~|" +
        process.env.REACT_APP_WEB_URL +
        "|~|" +
        grp +
        '"}';
      if (!(window.JSInterface === undefined))
        window.JSInterface.CallWSMethod(rejoinData);
      return;
    }

    return window.close();
  }, []);

  return (
    <>
      <div
        className="attendee-host-disconnect"
        style={{ display: "flex" }}
      ></div>
    </>
  );
}
export default memo(RejoinComp);
